import React from 'react';
import PropTypes from 'prop-types';

import axios from 'axios';
import { render } from 'react-dom';
import Konva from 'konva';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

import Paper from '@material-ui/core/Paper';

import ClassSelector from './class_selector.jsx';
import BoundingBoxRect from './bounding_box_rect.jsx';
import { Layer, Rect, Stage, Group, Image } from 'react-konva';
import { withStyles } from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom'

const styles = {
    root: {
        flexGrow: 1,
    },
    flex: {
        flex: 1,
    },
    menuButton: {
    },
    stage: {
        cursor: 'crosshair'
    }
};

class Labeler extends React.Component {
    state = {
        image: null,
        dataset: null,
        classList: [],
        datasetItem: null,
        shapes: [],
        colors: {},
        colorsList: [],
        curColor: null,
        curLabel: null,
        isDrawing: false,
        isDrawingMode: false,
    }

    setLabel(className) {
        this.setState({ isDrawingMode: true, curColor: this.state.colorsList[this.state.classList.indexOf(className)], curLabel: className });
    }

    assignColors(classList) {
        let colors = ['#6200EE', '#3700B3', '#03DAC6', '#C51162', '#FFDE03', '#33691E', '#03A9F4'];
        let index = 0;

        return classList.map(cl => {
            let color = colors[index];


            index++;

            if (index == colors.length)
                index = 0;

            return color;
        })
    }

    componentDidMount() {
        let { id } = this.props;

        axios.get(`${process.env.REACT_APP_API_URL}/api/dataset/${this.props.match.params.dataset_id}`)
            .then(res => {
                const ds = res.data;

                this.setState({ dataset: ds, classList: ds.class_list, colorsList: this.assignColors(ds.class_list) });
            })

        axios.get(`${process.env.REACT_APP_API_URL}/api/dataset-item/${this.props.match.params.dataset_item_id}`)
            .then(res => {
                const di = res.data;
                this.setState({ datasetItem: di, loading: false });

                const image = new window.Image();
                image.src = di.fields.cloud_location;

                image.onload = () => {
                    this.setState({
                        image: image
                    });
                };
            })
    }

    render() {
        const { classes } = this.props;
        const { classList, colorsList } = this.state;
        return (
            <div className={classes.root}>
                <ClassSelector
                    classList={classList}
                    colorsList={colorsList}
                    setLabel={this.setLabel.bind(this)}
                    />

                <Paper>
                    <AppBar position='static'>
                        <Toolbar>
                            <Button
                                variant="contained"
                                style={{
                                    backgroundColor: this.state.curColor,
                                    color: this.state.curLabel ? '#ffffff' : '#000000',
                                }}
                            >{this.state.curLabel || "Pick a class"}</Button>
                               
                        
                            <Typography variant="title" color="inherit" className={classes.flex}>Image Labeler 2000</Typography>
                        </Toolbar>
                    </AppBar>

                    <Stage width={window.innerWidth} height={window.innerHeight} className={classes.stage}
                        onContextMenu={e => {
                            e.evt.preventDefault();
                        }}
                        onContentClick={this.handleClick}
                        onContentMouseMove={this.handleMouseMove}
                        >
                        <Layer>
                        <Image image={this.state.image} />
                        {/* 
                          render the shapes array - each element in 'shapes' renders a ColoredRect component 
                          with that element's dimensions. Any time these dimensions change (in the handle 
                          functions), the ColoredRect rerenders to reflect those changes.
                          */}
                        {this.state.shapes.map(shape => {
                            return (
                                <BoundingBoxRect
                                    color={shape.color}
                                    label={shape.label}
                                    x={shape.x}
                                    y={shape.y}
                                    width={shape.width}
                                    height={shape.height}
                                    isDrawingMode={this.state.isDrawingMode}
                                    // pass isDrawingMode so we know when we can click on a shape
                                />
                            );
                        })}
                        </Layer>
                    </Stage>
                </Paper>
            </div>
        );
    }

    handleClick = (e) => {
        if (e.evt && e.evt.button == 2) {
            if (this.state.isDrawing) {
                this.setState({
                    isDrawing: false,
                    shapes: this.state.shapes.slice(0, this.state.shapes.length-1),
                })

                if (e.evt.stopPropagation)
                    e.evt.stopPropagation();

                e.evt.cancelBubble = true;
                e.evt.preventDefault();
                return
            }
            else {
                this.setState({
                    shapes: this.state.shapes.slice(0, this.state.shapes.length-1),
                })


                if (e.evt.stopPropagation)
                    e.evt.stopPropagation();

                e.evt.cancelBubble = true;
                e.evt.preventDefault();

                return;
            }
        }

        if (!this.state.isDrawingMode) return;
        // if we are drawing a shape, a click finishes the drawing
        if(this.state.isDrawing) {
            this.setState({
                isDrawing: !this.state.isDrawing,
            })

            const currShapeIndex = this.state.shapes.length - 1;
            const currShape = this.state.shapes[currShapeIndex];

            return;
        }

        // otherwise, add a new rectangle at the mouse position with 0 width and height,
        // and set isDrawing to true
        const newShapes = this.state.shapes.slice();
        newShapes.push({
            x: e.evt.layerX,
            y: e.evt.layerY,
            width: 0,
            height: 0,
        });

        this.setState({
            isDrawing: true,
            shapes: newShapes,
        })
    }

    handleMouseMove= (e) => {
        if (!this.state.isDrawingMode) return;

        const mouseX = e.evt.layerX;
        const mouseY = e.evt.layerY;

        // update the current rectangle's width and height based on the mouse position
        if (this.state.isDrawing) {
            // get the current shape (the last shape in this.state.shapes)
            const currShapeIndex = this.state.shapes.length - 1;
            const currShape = this.state.shapes[currShapeIndex];
            const newWidth = mouseX - currShape.x;
            const newHeight = mouseY - currShape.y;

            const newShapesList = this.state.shapes.slice();
            newShapesList[currShapeIndex] = {
                label: this.state.curLabel,
                color: this.state.curColor,
                x: currShape.x,   // keep starting position the same
                y: currShape.y,
                width: newWidth,  // new width and height
                height: newHeight
            }

            this.setState({
                shapes: newShapesList,
            });
        }
    }

    handleCheckboxChange = () => {
        // toggle drawing mode
        this.setState({
            isDrawingMode: !this.state.isDrawingMode,
        })
    }
}

Labeler.propTypes = {
  classes: PropTypes.object.isRequired,
};


export default withRouter(withStyles(styles)(Labeler));



// WEBPACK FOOTER //
// ./src/components/labeler/labeler.jsx